import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statModuleLocaleModule: LocaleModule = {
  name: "statModule",
  messages: { en: en, it: it },
};
